import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import { ProjectComplet, StateInterface } from '@/interfaces/projects';


const projectDetailsModule: Module<ProjectComplet, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default projectDetailsModule;